export default __webpack_public_path__ + "static/deviceSpecific-4aab34167dc28b98348f395ff03f6210.png";